<div class="cockpit-content">
  <h1>{{ 'm2.sprint9.cockpit.card.funktionenstatistiken.personen.title' | translate }}</h1>

  <app-chart-download-button (buttonClick)="exportTable1()">
    @if (isForM2) {
      <h2 class="title" translate>sprint9.cockpit.card.all.tabelle</h2>
    }
    @if (!isForM2) {
      <h2 class="title" translate>m1.sprint9.cockpit.card.funktionenstatistiken.fn.subtitle</h2>
    }
  </app-chart-download-button>

  <div class="table-wrapper">
    <table id="funkstat-personen.fn" class="striped">
      <thead>
        <tr>
          <td class="no-border"></td>
          @if (!isForM2) {
            <th scope="colgroup" style="width: 140px" class="header bold centered border-bold-left pt-md-2" [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bst.umbruch' |translate"></th>
          }
          @if (!isForM2) {
            <th scope="colgroup" style="width: 180px;" class="header bold centered border-bold-left pt-md-2" [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bkn.umbruch' |translate"></th>
          }
          @if (isForM2) {
            <th scope="colgroup" class="header bold centered border-bold-left pt-md-2"  [innerHTML]="'m2.sprint5.cockpit.card.funktionenstatistiken.funktionswert.umbruch' |translate"></th>
          }
          <th colspan="3" scope="colgroup" class="header bold centered border-bold-left" translate>m2.sprint4.cockpit.card.funktionenstatistiken.anzahl</th>
          <th colspan="2" scope="colgroup" class="header bold centered border-bold-right" translate>m2.sprint4.cockpit.card.funktionenstatistiken.anteil-in-perc</th>
          <th colspan="2" scope="colgroup" class="header bold centered border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.durchschnittwertAlter</th>
          <th colspan="2" scope="colgroup" class="header bold centered border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.durchschnittwertDienstjahre</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <th scope="col" colspan="1" class="header bold centered border-bold-left border-bold-right"translate>m2.sprint4.cockpit.card.funktionenstatistiken.funktion</th>
          @if (!isForM2) {
            <td class="centered border-bold-right"></td>
          }
          <td class="centered border-bold-right"></td>
          <th scope="col" class="centered" translate>m2.sprint4.common.alle</th>
          <th scope="col" class="centered" translate>i18n.common.maenner</th>
          <th scope="col" class="centered" translate>i18n.common.frauen</th>
          <th scope="col" class="centered" translate>i18n.common.maenner</th>
          <th scope="col" class="centered border-bold-right" translate>i18n.common.frauen</th>

          <th scope="col" class="centered" translate>i18n.common.maenner</th>
          <th scope="col" class="centered border-bold-right" translate>i18n.common.frauen</th>
          <th scope="col" class="centered" translate>i18n.common.maenner</th>
          <th scope="col" class="centered border-bold-right" translate>i18n.common.frauen</th>
        </tr>

        @for (item of nachFunktion; track item) {
          <tr class="content">
            <th scope="col" colspan="1" class="border-bold-left border-bold-right">{{item?.funktionId | retrieveCaption: funktionen}}</th>
            @if (!isForM2) {
              <td class="text-align-right border-bold-right">{{item?.BST | numberFormat: crtLocale }}</td>
            }
            @if (!isForM2) {
              <td class="text-align-right border-bold-right">{{item?.BKN | numberFormat: crtLocale }}</td>
            }
            @if (isForM2) {
              <td class="text-align-right border-bold-right">{{item?.funktionsWert | numberFormat: crtLocale }}</td>
            }
            <td class="text-align-right">{{item?.anzahlMitarbeiter | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0'}}</td>
            <td class="text-align-right">{{item?.anzahlMaenner | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0'}}</td>
            <td class="text-align-right">{{item?.anzahlFrauen | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0'}}</td>
            <td class="text-align-right">{{item?.anteilMaenner | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0.0%'}}</td>
            <td class="text-align-right border-bold-right">{{item?.anteilFrauen | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0.0%'}}</td>
            <td class="text-align-right">{{item?.alterMaenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.alterFrauen | numberFormat: crtLocale }}</td>
            <td class="text-align-right">{{item?.dienstjahreMaenner | numberFormat: crtLocale }}</td>
            <td class="text-align-right border-bold-right">{{item?.dienstjahreFrauen | numberFormat: crtLocale }}</td>
          </tr>
        }
      </tbody>
      <tfoot>
        <!-- total row -->
        <tr class="content">
          <th scope="col" colspan="1" class="border-bold-left border-bold-right border-bold-top"translate >i18n.common.total</th>
          <td class="text-align-right border-bold-right border-bold-top"></td>
          @if (!isForM2) {
            <td class="text-align-right border-bold-right border-bold-top"></td>
          }
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anzahlMitarbeiter | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anzahlMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anzahlFrauen | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anteilMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.anteilFrauen | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.alterMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.alterFrauen | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.dienstjahreMaenner | numberFormat: crtLocale }}</td>
          <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.dienstjahreFrauen | numberFormat: crtLocale }}</td>
        </tr>
        <tr>
          @if (!isForM2) {
            <td colspan="12" class="hint pt-1" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.footer-hint</td>
          }
          @if (isForM2) {
            <td colspan="11" class="hint pt-1" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.footer-hint</td>
          }
        </tr>
        <tfoot>
        </table>
      </div>

      <div style="padding-bottom: 15px;padding-top: 15px;">
      </div>

      @if (!isForM2) {
        <div>
          <app-chart-download-button (buttonClick)="exportTable2()">
            <h2 class="title" translate>m1.sprint9.cockpit.card.funktionenstatistiken.bst-anf.subtitle</h2>
          </app-chart-download-button>
          <div class="table-wrapper">
            <table id="funkstat-personen.bst-anf" class="striped">
              <thead>
                <tr>
                  <th scope="colgroup" style="width: 140px" class="header bold centered border-bold-left pt-md-2" [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bst.umbruch' |translate"></th>
                  <th scope="colgroup" style="width: 180px;" class="header bold centered border-bold-left pt-md-2" [innerHTML]="'m1.sprint10.cockpit.card.funktionenstatistiken.bkn.umbruch' |translate"></th>
                  <th colspan="3" scope="colgroup" class="header bold centered border-bold-left" translate>m2.sprint4.cockpit.card.funktionenstatistiken.anzahl</th>
                  <th colspan="2" scope="colgroup" class="header bold centered border-bold-right" translate>m2.sprint4.cockpit.card.funktionenstatistiken.anteil-in-perc</th>
                  <th colspan="2" scope="colgroup" class="header bold centered border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.durchschnittwertAlter</th>
                  <th colspan="2" scope="colgroup" class="header bold centered border-bold-right" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.durchschnittwertDienstjahre</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td class="centered border-bold-left border-bold-right"></td>
                  <td class="centered border-bold-right"></td>
                  <th scope="col" class="centered" translate>m2.sprint4.common.alle</th>
                  <th scope="col" class="centered" translate>i18n.common.maenner</th>
                  <th scope="col" class="centered" translate>i18n.common.frauen</th>
                  <th scope="col" class="centered" translate>i18n.common.maenner</th>
                  <th scope="col" class="centered border-bold-right" translate>i18n.common.frauen</th>
                  <th scope="col" class="centered" translate>i18n.common.maenner</th>
                  <th scope="col" class="centered border-bold-right" translate>i18n.common.frauen</th>
                  <th scope="col" class="centered" translate>i18n.common.maenner</th>
                  <th scope="col" class="centered border-bold-right" translate>i18n.common.frauen</th>
                </tr>
                @for (item of nachCodierung; track item) {
                  <tr class="content">
                    <td class="text-align-right border-bold-left border-bold-right">{{item?.BST | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.BKN | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.anzahlMitarbeiter | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0'}}</td>
                    <td class="text-align-right">{{item?.anzahlMaenner | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0'}}</td>
                    <td class="text-align-right">{{item?.anzahlFrauen | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0'}}</td>
                    <td class="text-align-right">{{item?.anteilMaenner | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0.0%'}}</td>
                    <td class="text-align-right border-bold-right">{{item?.anteilFrauen | numberFormat: crtLocale | replaceNullOrUndefinedTo:'0.0%'}}</td>
                    <td class="text-align-right">{{item?.alterMaenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.alterFrauen | numberFormat: crtLocale }}</td>
                    <td class="text-align-right">{{item?.dienstjahreMaenner | numberFormat: crtLocale }}</td>
                    <td class="text-align-right border-bold-right">{{item?.dienstjahreFrauen | numberFormat: crtLocale }}</td>
                  </tr>
                }
              </tbody>
              <tfoot>
                <!-- total row -->
                <tr class="content">
                  <th scope="col" colspan="1" class="border-bold-left border-bold-right border-bold-top"translate >i18n.common.total</th>
                  @if (!isForM2) {
                    <td class="text-align-right border-bold-right border-bold-top"></td>
                  }
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anzahlMitarbeiter | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anzahlMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anzahlFrauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.anteilMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.anteilFrauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.alterMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.alterFrauen | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-top">{{gesamtesUnternehmen?.dienstjahreMaenner | numberFormat: crtLocale }}</td>
                  <td class="text-align-right border-bold-right border-bold-top">{{gesamtesUnternehmen?.dienstjahreFrauen | numberFormat: crtLocale }}</td>
                </tr>
                <tr>
                  <td colspan="12" class="hint pt-1" translate>m2.sprint9.cockpit.card.funktionenstatistiken.personen.footer-hint</td>
                </tr>
                <tfoot>
                </table>
              </div>
            </div>
          }
        </div>
